/**
 * Shared image load error handler.
 */
export function handleImageLoadError(e: Event): void {
  const target = e.target;
  if (target && target instanceof HTMLImageElement) {
    target.hidden = true;
  }
}
